import React from 'react';
import { Trans } from 'react-i18next';
import { ROUTE } from 'constants/route';
import ButtonAdd from 'components/ButtonAdd';
import { RIGHTS } from 'constants/rights';

const Actions = () => (
  <ButtonAdd
    size="small"
    to={ROUTE.CONSULTANT_DETAIL.replace(':recordId', 'new')}
    right={RIGHTS.CONSULTANT.ADD}
  >
    <Trans>CONSULTANT.ADD</Trans>
  </ButtonAdd>
);

export default Actions;
